import { LanguageType } from '@eo-storefronts/eo-core'

export default class LanguageHelper {
  private static readonly supportedLanguages: readonly LanguageType[] = [
    'en',
    'fr',
    'nl',
    'de',
    'pt',
    'es',
    'it',
    'no'
  ] as const

  public static isLanguageSupported(language: string): boolean {
    return this.supportedLanguages.includes(language as LanguageType)
  }
}
